import { Component } from 'react';
import i18next from 'i18next';

/**
 * Global React Error Boundary — catches component crashes.
 * Shows friendly error screen instead of blank page.
 */
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, showDetails: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
    // Future: send to Sentry
  }

  render() {
    if (this.state.hasError) {
      const t = (key, fallback) => i18next.t(key) || fallback;
      return (
        <div className="min-h-[100dvh] flex items-center justify-center bg-[var(--aif-bg-page)] px-6">
          <div className="max-w-sm text-center space-y-4">
            <div className="text-5xl">{'\u26A0\uFE0F'}</div>
            <h1 className="text-lg font-semibold text-[var(--aif-text-primary)]">
              {t('error.title')}
            </h1>
            <p className="text-sm text-[var(--aif-text-muted)]">
              {t('error.reloadHint')}
            </p>
            <button
              onClick={() => window.location.reload()}
              className="w-full py-3 rounded-xl bg-[var(--aif-color-primary)] text-white font-medium text-sm"
            >
              {t('error.reload')}
            </button>
            <button
              onClick={() => this.setState(s => ({ showDetails: !s.showDetails }))}
              className="text-xs text-[var(--aif-text-muted)] hover:text-[var(--aif-text-secondary)]"
            >
              {this.state.showDetails ? t('error.hideDetails') : t('error.showDetails')}
            </button>
            {this.state.showDetails && (
              <pre className="text-left text-[10px] text-red-400 bg-[var(--aif-bg-surface)] p-3 rounded-lg overflow-auto max-h-40 border border-[var(--aif-border-default)]">
                {this.state.error?.toString()}
              </pre>
            )}
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
